import { Dialog, DialogContent, Box, Typography, Avatar } from '@mui/material';
import { Phone } from 'lucide-react';

interface CallEndedDialogProps {
  open: boolean;
  onClose: () => void;
  agentName: string;
  callDuration: string;
}

export const CallEndedDialog = ({
  open,
  onClose,
  agentName,
  callDuration,
}: CallEndedDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        elevation: 2,
        sx: {
          borderRadius: 4,
          overflow: 'hidden',
          maxWidth: 320,
          width: '100%',
          margin: 2,
          // Animation effect with sx prop instead of motion component
          opacity: 1,
          transform: 'scale(1)',
          transition: 'opacity 300ms, transform 300ms',
          '&.MuiDialog-paper': {
            opacity: open ? 1 : 0,
            transform: open ? 'scale(1)' : 'scale(0.9)',
          },
        },
      }}
    >
      <DialogContent sx={{ textAlign: 'center', py: 4 }}>
        <Avatar
          sx={{
            width: 64,
            height: 64,
            bgcolor: 'error.light',
            mx: 'auto',
            mb: 2,
          }}
        >
          <Phone style={{ transform: 'rotate(135deg)', color: '#C11919' }} />
        </Avatar>

        <Typography variant="h6" gutterBottom>
          Call Ended
        </Typography>

        <Typography variant="body2" color="text.secondary" paragraph>
          Your call with {agentName} has ended.
        </Typography>

        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Call duration: {callDuration}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
